import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Bus as BusIcon, GraduationCap as GraduationCapIcon, Landmark as LandmarkIcon, MessageCircle as MessageCircleIcon, Check as CheckIcon, ArrowLeft as ArrowLeftIcon } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { LanguageProvider } from '../context/LanguageContext';
export function SikhHeritageForwardPage() {
  useEffect(() => {
    document.body.classList.add('bg-[#fefaf3]', 'text-[#0f1729]', 'overflow-x-hidden');
    return () => {
      document.body.classList.remove('bg-[#fefaf3]', 'text-[#0f1729]', 'overflow-x-hidden');
    };
  }, []);
  const fadeInUp = {
    initial: {
      opacity: 0,
      y: 30
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true
    },
    transition: {
      duration: 0.8
    }
  };
  return <LanguageProvider data-id="element-7117" data-mp="3lfzmm3173qpx">
      <div className="relative min-h-screen bg-[#fefaf3] font-sans" data-id="element-7118" data-mp="3lghpvjm9z57c">
        <Navbar data-id="element-7119" data-mp="3qet0vxob3lr5" />

        {/* 1. Hero Section */}
        <section className="relative min-h-[90vh] bg-[#0a0f1f] flex flex-col items-center justify-center overflow-hidden pt-20 pb-16" data-id="element-7120" data-mp="3qbf18x711qne">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#c89b3c]/15 via-[#0a0f1f] to-[#0a0f1f]" data-id="element-7121" data-mp="3ygdwg55rca1"></div>

          <div className="relative z-10 container mx-auto px-6 text-center max-w-4xl" data-id="element-7122" data-mp="8zm6mdytizjk">
            <motion.p {...fadeInUp} className="text-[#c89b3c] tracking-[0.3em] text-[10px] md:text-xs uppercase mb-6 font-medium" data-id="element-7123" data-mp="d0y1oz0gocz5">
              A Program of The Kingdoms of Punjab
            </motion.p>

            <motion.h1 {...fadeInUp} transition={{
            duration: 0.8,
            delay: 0.1
          }} className="font-serif text-5xl md:text-7xl lg:text-8xl text-[#fefaf3] mb-6 tracking-tight leading-[1.1]" data-id="element-7124" data-mp="2jq4aubk694su">
              Sikh Heritage Forward
            </motion.h1>

            <motion.p {...fadeInUp} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="text-lg md:text-2xl text-[#fefaf3]/70 font-light mb-8 max-w-3xl mx-auto" data-id="element-7125" data-mp="2co7iboppoqg1">
              A pay-it-forward student access program for The Kingdoms of Punjab
            </motion.p>

            <motion.p {...fadeInUp} transition={{
            duration: 0.8,
            delay: 0.3
          }} className="text-[#fefaf3]/50 font-light leading-relaxed mb-12 max-w-2xl mx-auto text-sm md:text-base" data-id="element-7126" data-mp="2vk7df8dzka3u">
              Sponsors fund student bus access during Sikh Heritage Month and
              beyond, supporting both student access AND the creation and
              continuity of this immersive cultural project.
            </motion.p>

            <motion.div {...fadeInUp} transition={{
            duration: 0.8,
            delay: 0.4
          }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-7127" data-mp="1snl44dji0j4">
              <a href="https://wa.me/14169998778?text=I%20would%20like%20to%20sponsor%20a%20bus%20for%20Sikh%20Heritage%20Forward" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#c89b3c] hover:bg-[#b8860b] text-[#0a0f1f] px-8 py-4 text-xs md:text-sm tracking-[0.15em] uppercase font-medium transition-colors duration-300" data-id="element-7128" data-mp="3sxdymuunkim3">
                Sponsor a Bus
              </a>
              <a href="#tiers" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 border border-[#c89b3c]/50 hover:border-[#c89b3c] text-[#fefaf3] px-8 py-4 text-xs md:text-sm tracking-[0.15em] uppercase font-medium transition-colors duration-300" data-id="element-7129" data-mp="2vbq5cithuges">
                View Sponsorship Tiers
              </a>
            </motion.div>

            <motion.p {...fadeInUp} transition={{
            duration: 0.8,
            delay: 0.5
          }} className="mt-12 text-[#c89b3c]/40 text-xs font-light italic" data-id="element-7130" data-mp="3tt1brbzdxipa">
              In support of Sikh Heritage Month and beyond
            </motion.p>
          </div>
        </section>

        {/* 2. Why It Matters Section */}
        <section className="py-24 md:py-32 bg-[#fefaf3]" data-id="element-7131" data-mp="3aw9vlbf53jpg">
          <div className="container mx-auto px-6 max-w-4xl" data-id="element-7132" data-mp="35x6prorc59gf">
            <motion.div {...fadeInUp} className="text-center mb-16" data-id="element-7133" data-mp="35yrnfn8y58ii">
              <p className="text-[#c89b3c] tracking-[0.2em] text-xs uppercase mb-4 font-semibold" data-id="element-7134" data-mp="19329nj50u3ul">
                Why It Matters
              </p>
              <h2 className="font-serif text-4xl md:text-5xl text-[#0f1729] mb-8" data-id="element-7135" data-mp="1bot495ctwt3q">
                Heritage is not preserved by accident.
              </h2>
              <div className="w-16 h-px bg-[#c89b3c]/30 mx-auto" data-id="element-7136" data-mp="1gmbi9a5pdyil"></div>
            </motion.div>

            <motion.div {...fadeInUp} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="prose prose-lg mx-auto text-[#0f1729]/70 font-light leading-relaxed" data-id="element-7137" data-mp="1lf4ltupfr0t3">
              <p className="mb-6" data-id="element-7138" data-mp="xoide2bireik">
                Many young Sikhs grow up disconnected from the depth of their
                own heritage. They learn fragments of history, but rarely get to
                step inside it, feel it, and understand the magnitude of what
                their ancestors built.
              </p>
              <p className="mb-6" data-id="element-7139" data-mp="2e2ial5izcq24">
                The Kingdoms of Punjab is a once-in-a-generation immersive
                cultural experience designed to change that. But without
                sponsorship, students from public schools, Gurdwara youth
                groups, and diaspora communities cannot easily access it.
              </p>
              <p className="mb-10" data-id="element-7140" data-mp="s0tga56ny38g">
                Sponsors are the bridge. By funding student access, you are not
                just buying a ticket—you are making heritage education
                accessible while securing the project's future as a permanent
                cultural institution.
              </p>

              <blockquote className="border-l-2 border-[#c89b3c] pl-6 py-2 my-12" data-id="element-7141" data-mp="3rgq5ean801qr">
                <p className="font-serif text-2xl md:text-3xl text-[#c89b3c] italic leading-snug" data-id="element-7142" data-mp="91pdvf9mn7pr">
                  "When a young Sikh sees their history alive—not in a textbook,
                  but all around them—something awakens. That awakening is what
                  we are funding."
                </p>
              </blockquote>
            </motion.div>
          </div>
        </section>

        {/* 3. What Your Sponsorship Funds */}
        <section className="py-24 md:py-32 bg-[#f9f4ec]" data-id="element-7143" data-mp="2yjxr35m7k3i3">
          <div className="container mx-auto px-6 max-w-6xl" data-id="element-7144" data-mp="33cqv1r9ur7t4">
            <motion.div {...fadeInUp} className="text-center mb-16" data-id="element-7145" data-mp="33ebrxnjn32u5">
              <p className="text-[#c89b3c] tracking-[0.2em] text-xs uppercase mb-4 font-semibold" data-id="element-7146" data-mp="2oonmca4fdi0m">
                Where The Funds Go
              </p>
              <h2 className="font-serif text-4xl md:text-5xl text-[#0f1729] mb-8" data-id="element-7147" data-mp="3hc08ij6obnte">
                Three pillars of impact.
              </h2>
              <div className="w-16 h-px bg-[#c89b3c]/30 mx-auto" data-id="element-7148" data-mp="3m9s35kypdo1a"></div>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-7149" data-mp="37csq3hl312zf">
              <motion.div {...fadeInUp} transition={{
              duration: 0.6,
              delay: 0.1
            }} className="bg-[#fefaf3] border border-[#c89b3c]/20 p-10 text-center hover:border-[#c89b3c]/50 transition-colors duration-300" data-id="element-7150" data-mp="3ccngzl4uxskh">
                <GraduationCapIcon className="w-10 h-10 text-[#c89b3c] mx-auto mb-6" data-id="element-7151" data-mp="1i88x0ee1su68" />
                <h3 className="font-serif text-2xl text-[#0f1729] mb-4" data-id="element-7152" data-mp="1d7v09shwd6ni">
                  Student Access
                </h3>
                <p className="text-[#0f1729]/60 font-light leading-relaxed text-sm" data-id="element-7153" data-mp="189jr7jzff06c">
                  Funds free or subsidized tickets for schools, Gurdwara youth
                  programs, and community groups to experience the immersive
                  exhibition.
                </p>
              </motion.div>

              <motion.div {...fadeInUp} transition={{
              duration: 0.6,
              delay: 0.2
            }} className="bg-[#fefaf3] border border-[#c89b3c]/20 p-10 text-center hover:border-[#c89b3c]/50 transition-colors duration-300" data-id="element-7154" data-mp="1w0p6ny1gfqg4">
                <BusIcon className="w-10 h-10 text-[#c89b3c] mx-auto mb-6" data-id="element-7155" data-mp="2exqedqme84nr" />
                <h3 className="font-serif text-2xl text-[#0f1729] mb-4" data-id="element-7156" data-mp="2evdpsum4qw1q">
                  Transportation
                </h3>
                <p className="text-[#0f1729]/60 font-light leading-relaxed text-sm" data-id="element-7157" data-mp="6dnf04ul8hz4">
                  Covers school buses bringing students from across the GTA to
                  the Illuminarium experience, removing the biggest logistical
                  barrier.
                </p>
              </motion.div>

              <motion.div {...fadeInUp} transition={{
              duration: 0.6,
              delay: 0.3
            }} className="bg-[#fefaf3] border border-[#c89b3c]/20 p-10 text-center hover:border-[#c89b3c]/50 transition-colors duration-300" data-id="element-7158" data-mp="kehqwxguh12j">
                <LandmarkIcon className="w-10 h-10 text-[#c89b3c] mx-auto mb-6" data-id="element-7159" data-mp="y4l99dclsamp" />
                <h3 className="font-serif text-2xl text-[#0f1729] mb-4" data-id="element-7160" data-mp="1358wdnxpo7bn">
                  Project Continuity
                </h3>
                <p className="text-[#0f1729]/60 font-light leading-relaxed text-sm" data-id="element-7161" data-mp="183k700vtylux">
                  Supports ongoing development, programming, and the long-term
                  survival of The Kingdoms of Punjab as a permanent cultural
                  institution.
                </p>
              </motion.div>
            </div>
          </div>
        </section>

        {/* 4. Sponsorship Tiers */}
        <section id="tiers" className="py-24 md:py-32 bg-[#fefaf3]" data-id="element-7162" data-mp="72mej72a24ko">
          <div className="container mx-auto px-6 max-w-7xl" data-id="element-7163" data-mp="bytd2escgdsl">
            <motion.div {...fadeInUp} className="text-center mb-16" data-id="element-7164" data-mp="gyfpwn49fs0v">
              <p className="text-[#c89b3c] tracking-[0.2em] text-xs uppercase mb-4 font-semibold" data-id="element-7165" data-mp="h0sdbfsseulb">
                Sponsorship Tiers
              </p>
              <h2 className="font-serif text-4xl md:text-5xl text-[#0f1729] mb-6" data-id="element-7166" data-mp="pycj921lhf29">
                Choose your level of patronage.
              </h2>
              <p className="text-[#0f1729]/60 font-light max-w-2xl mx-auto" data-id="element-7167" data-mp="2nri52plmm9jy">
                Every tier is meaningful and recognized. Your contribution
                directly funds student access and preserves our cultural legacy.
              </p>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-7168" data-mp="2fey8cua9kvgw">
              {/* Tier 1 */}
              <motion.div {...fadeInUp} transition={{
              duration: 0.5,
              delay: 0.1
            }} className="bg-[#fefaf3] border border-[#c89b3c]/20 p-8 flex flex-col hover:border-[#c89b3c]/40 transition-colors" data-id="element-7169" data-mp="2afbz0vxk3zdd">
                <h3 className="font-serif text-2xl text-[#0f1729] mb-2" data-id="element-7170" data-mp="2y566sz30qxqr">
                  Bus Sponsor
                </h3>
                <div className="text-3xl text-[#c89b3c] font-medium mb-6" data-id="element-7171" data-mp="2p6u9yfbk73pv">
                  $10,000
                </div>
                <ul className="space-y-4 mb-8 flex-1" data-id="element-7172" data-mp="1ira2pbre2ve8">
                  <li className="flex items-start gap-3 text-sm text-[#0f1729]/70 font-light" data-id="element-7173" data-mp="1dr5ojsdyecr6">
                    <CheckIcon className="w-4 h-4 text-[#c89b3c] mt-0.5 flex-shrink-0" data-id="element-7174" data-mp="1f8bdbz3ifnn1" />
                    <span data-id="element-7175" data-mp="1f6i3yc1iipbc">Funds: 1 full bus (~50 students)</span>
                  </li>
                  <li className="flex items-start gap-3 text-sm text-[#0f1729]/70 font-light" data-id="element-7176" data-mp="1k6mk20yidi11">
                    <CheckIcon className="w-4 h-4 text-[#c89b3c] mt-0.5 flex-shrink-0" data-id="element-7177" data-mp="167d8xfp5te3x" />
                    <span data-id="element-7178" data-mp="1a7nc6klkhqf3">
                      Recognition: Listed as a Bus Sponsor in program materials
                    </span>
                  </li>
                  <li className="flex items-start gap-3 text-sm text-[#0f1729]/70 font-light" data-id="element-7179" data-mp="1191x4zfb0tj2">
                    <CheckIcon className="w-4 h-4 text-[#c89b3c] mt-0.5 flex-shrink-0" data-id="element-7180" data-mp="mk5rf90pzslm" />
                    <span data-id="element-7181" data-mp="rih19jr0m33u">
                      Includes: 2 complimentary VIP tickets to opening
                    </span>
                  </li>
                  <li className="flex items-start gap-3 text-sm text-[#0f1729]/70 font-light" data-id="element-7182" data-mp="dkadwxjozlif">
                    <CheckIcon className="w-4 h-4 text-[#c89b3c] mt-0.5 flex-shrink-0" data-id="element-7183" data-mp="igr03m7bzpsv" />
                    <span data-id="element-7184" data-mp="3v2pkrwzl2tsg">Tax receipt provided</span>
                  </li>
                </ul>
                <a href="https://wa.me/14169998778?text=I%20would%20like%20to%20become%20a%20Bus%20Sponsor%20for%20Sikh%20Heritage%20Forward" target="_blank" rel="noopener noreferrer" className="block w-full text-center border border-[#c89b3c] text-[#c89b3c] hover:bg-[#c89b3c] hover:text-[#fefaf3] py-3 text-xs tracking-[0.15em] uppercase font-medium transition-colors" data-id="element-7185" data-mp="3q3lf3gbvbe6v">
                  Become a Bus Sponsor
                </a>
              </motion.div>

              {/* Tier 2 */}
              <motion.div {...fadeInUp} transition={{
              duration: 0.5,
              delay: 0.2
            }} className="bg-[#fefaf3] border border-[#c89b3c]/20 p-8 flex flex-col hover:border-[#c89b3c]/40 transition-colors" data-id="element-7186" data-mp="mm34j14pnt2r">
                <h3 className="font-serif text-2xl text-[#0f1729] mb-2" data-id="element-7187" data-mp="2q3j9fx2rccq3">
                  Heritage Sponsor
                </h3>
                <div className="text-3xl text-[#c89b3c] font-medium mb-6" data-id="element-7188" data-mp="2v09rgpy4hie5">
                  $25,000
                </div>
                <ul className="space-y-4 mb-8 flex-1" data-id="element-7189" data-mp="2zunmgr8vhnia">
                  <li className="flex items-start gap-3 text-sm text-[#0f1729]/70 font-light" data-id="element-7190" data-mp="33t392u11ktv6">
                    <CheckIcon className="w-4 h-4 text-[#c89b3c] mt-0.5 flex-shrink-0" data-id="element-7191" data-mp="274x9wmmw2toa" />
                    <span data-id="element-7192" data-mp="2c26vfr75ql6u">Funds: 3 buses (~150 students) over the season</span>
                  </li>
                  <li className="flex items-start gap-3 text-sm text-[#0f1729]/70 font-light" data-id="element-7193" data-mp="2g4aize73pg8h">
                    <CheckIcon className="w-4 h-4 text-[#c89b3c] mt-0.5 flex-shrink-0" data-id="element-7194" data-mp="2l3wy5t6hp6jx" />
                    <span data-id="element-7195" data-mp="3rk8nd4rc3e3d">
                      Recognition: Named on the Heritage Wall + program credits
                    </span>
                  </li>
                  <li className="flex items-start gap-3 text-sm text-[#0f1729]/70 font-light" data-id="element-7196" data-mp="bl3yucnm0yg">
                    <CheckIcon className="w-4 h-4 text-[#c89b3c] mt-0.5 flex-shrink-0" data-id="element-7197" data-mp="agkxgs8r3kah" />
                    <span data-id="element-7198" data-mp="5it6q1jue47v">
                      Includes: 4 VIP tickets + private behind-the-scenes tour
                    </span>
                  </li>
                  <li className="flex items-start gap-3 text-sm text-[#0f1729]/70 font-light" data-id="element-7199" data-mp="3svvk1pm8xbo1">
                    <CheckIcon className="w-4 h-4 text-[#c89b3c] mt-0.5 flex-shrink-0" data-id="element-7200" data-mp="3nvzbre6imy2o" />
                    <span data-id="element-7201" data-mp="3ix62xz26bv8u">Hosted recognition dinner</span>
                  </li>
                </ul>
                <a href="https://wa.me/14169998778?text=I%20would%20like%20to%20become%20a%20Heritage%20Sponsor%20for%20Sikh%20Heritage%20Forward" target="_blank" rel="noopener noreferrer" className="block w-full text-center border border-[#c89b3c] text-[#c89b3c] hover:bg-[#c89b3c] hover:text-[#fefaf3] py-3 text-xs tracking-[0.15em] uppercase font-medium transition-colors" data-id="element-7202" data-mp="3dy326qt88b6o">
                  Become a Heritage Sponsor
                </a>
              </motion.div>

              {/* Tier 3 - Featured */}
              <motion.div {...fadeInUp} transition={{
              duration: 0.5,
              delay: 0.3
            }} className="bg-[#fefaf3] border-2 border-[#c89b3c] p-8 flex flex-col relative shadow-[0_0_30px_rgba(200,155,60,0.15)] lg:-translate-y-4" data-id="element-7203" data-mp="2sn5npe8w2oa5">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#c89b3c] text-[#0a0f1f] px-4 py-1 text-[10px] tracking-[0.2em] uppercase font-bold whitespace-nowrap" data-id="element-7204" data-mp="3pcd98m9icxe2">
                  Most Popular
                </div>
                <h3 className="font-serif text-2xl text-[#0f1729] mb-2" data-id="element-7205" data-mp="3geksddo51hok">
                  Legacy Sponsor
                </h3>
                <div className="text-3xl text-[#c89b3c] font-medium mb-6" data-id="element-7206" data-mp="24y49199gqgwf">
                  $50,000
                </div>
                <ul className="space-y-4 mb-8 flex-1" data-id="element-7207" data-mp="1wfiyn0zikolv">
                  <li className="flex items-start gap-3 text-sm text-[#0f1729]/70 font-light" data-id="element-7208" data-mp="1sez4856brz3f">
                    <CheckIcon className="w-4 h-4 text-[#c89b3c] mt-0.5 flex-shrink-0" data-id="element-7209" data-mp="26eqdjslwcrb3" />
                    <span data-id="element-7210" data-mp="26cdzvrn6933u">
                      Funds: 6 buses (~300 students) + named education program
                    </span>
                  </li>
                  <li className="flex items-start gap-3 text-sm text-[#0f1729]/70 font-light" data-id="element-7211" data-mp="1dr48sh0xngmn">
                    <CheckIcon className="w-4 h-4 text-[#c89b3c] mt-0.5 flex-shrink-0" data-id="element-7212" data-mp="18s144xov7cf7" />
                    <span data-id="element-7213" data-mp="1ng5p68be4015">
                      Recognition: Premium placement on Heritage Wall + named
                      scholarship in your honor
                    </span>
                  </li>
                  <li className="flex items-start gap-3 text-sm text-[#0f1729]/70 font-light" data-id="element-7214" data-mp="uytgfh3wn12s">
                    <CheckIcon className="w-4 h-4 text-[#c89b3c] mt-0.5 flex-shrink-0" data-id="element-7215" data-mp="q19ya643645k" />
                    <span data-id="element-7216" data-mp="4hoyd3iz6bih">
                      Includes: Reserved hosted table for 8 + private chef
                      interaction
                    </span>
                  </li>
                  <li className="flex items-start gap-3 text-sm text-[#0f1729]/70 font-light" data-id="element-7217" data-mp="efmm7pwxa6ak">
                    <CheckIcon className="w-4 h-4 text-[#c89b3c] mt-0.5 flex-shrink-0" data-id="element-7218" data-mp="jefyjf0h3r95" />
                    <span data-id="element-7219" data-mp="jc3d2rviayrc">Speaking opportunity at recognition dinner</span>
                  </li>
                </ul>
                <a href="https://wa.me/14169998778?text=I%20would%20like%20to%20become%20a%20Legacy%20Sponsor%20for%20Sikh%20Heritage%20Forward" target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-[#c89b3c] text-[#0a0f1f] hover:bg-[#b8860b] py-3 text-xs tracking-[0.15em] uppercase font-medium transition-colors" data-id="element-7220" data-mp="seupov04c0kk">
                  Become a Legacy Sponsor
                </a>
              </motion.div>

              {/* Tier 4 */}
              <motion.div {...fadeInUp} transition={{
              duration: 0.5,
              delay: 0.4
            }} className="bg-[#0f1729] border border-[#c89b3c]/30 p-8 flex flex-col" data-id="element-7221" data-mp="2vp7r23dwleym">
                <h3 className="font-serif text-2xl text-[#fefaf3] mb-2" data-id="element-7222" data-mp="2hooj0w9fu8wg">
                  Founding Patron
                </h3>
                <div className="text-3xl text-[#c89b3c] font-medium mb-6" data-id="element-7223" data-mp="3fb40vz5s18kj">
                  $100,000+
                </div>
                <ul className="space-y-4 mb-8 flex-1" data-id="element-7224" data-mp="3aewxad0us95r">
                  <li className="flex items-start gap-3 text-sm text-[#fefaf3]/70 font-light" data-id="element-7225" data-mp="35kj8wuklz2al">
                    <CheckIcon className="w-4 h-4 text-[#c89b3c] mt-0.5 flex-shrink-0" data-id="element-7226" data-mp="30lpqcnqgsl3k" />
                    <span data-id="element-7227" data-mp="1x0u9o4kvmoq">
                      Funds: A full Sikh Heritage Month program for an entire
                      school district
                    </span>
                  </li>
                  <li className="flex items-start gap-3 text-sm text-[#fefaf3]/70 font-light" data-id="element-7228" data-mp="etj36rmoso4d">
                    <CheckIcon className="w-4 h-4 text-[#c89b3c] mt-0.5 flex-shrink-0" data-id="element-7229" data-mp="9tmuwg6yiaj0" />
                    <span data-id="element-7230" data-mp="4utm312m77p6">
                      Recognition: Founding Patron status — permanent
                      recognition as an architect of the project
                    </span>
                  </li>
                  <li className="flex items-start gap-3 text-sm text-[#fefaf3]/70 font-light" data-id="element-7231" data-mp="xk0gbnv1db4m">
                    <CheckIcon className="w-4 h-4 text-[#c89b3c] mt-0.5 flex-shrink-0" data-id="element-7232" data-mp="sk5s5s2nazn9" />
                    <span data-id="element-7233" data-mp="ntpdk4n397zb">
                      Includes: All Legacy benefits + named scene/element within
                      the experience
                    </span>
                  </li>
                  <li className="flex items-start gap-3 text-sm text-[#fefaf3]/70 font-light" data-id="element-7234" data-mp="1ga01w0ro483a">
                    <CheckIcon className="w-4 h-4 text-[#c89b3c] mt-0.5 flex-shrink-0" data-id="element-7235" data-mp="1bjjlc7sjw6cp" />
                    <span data-id="element-7236" data-mp="1bhp4b4kegydw">Annual private reception with the creative team</span>
                  </li>
                </ul>
                <a href="https://wa.me/14169998778?text=I%20would%20like%20to%20become%20a%20Founding%20Patron%20for%20Sikh%20Heritage%20Forward" target="_blank" rel="noopener noreferrer" className="block w-full text-center border border-[#c89b3c] text-[#c89b3c] hover:bg-[#c89b3c] hover:text-[#0f1729] py-3 text-xs tracking-[0.15em] uppercase font-medium transition-colors" data-id="element-7237" data-mp="2z4ura0dwvmmb">
                  Become a Founding Patron
                </a>
              </motion.div>
            </div>
          </div>
        </section>

        {/* 5. Impact Section */}
        <section className="py-24 md:py-32 bg-[#0a0f1f] relative overflow-hidden" data-id="element-7238" data-mp="3qw0wgv8hoaig">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,_var(--tw-gradient-stops))] from-[#c89b3c]/10 via-transparent to-transparent" data-id="element-7239" data-mp="3vwol5a98wf9i"></div>
          <div className="container mx-auto px-6 relative z-10 max-w-5xl text-center" data-id="element-7240" data-mp="20s7cf78uhb7f">
            <motion.p {...fadeInUp} className="text-[#c89b3c] tracking-[0.2em] text-xs uppercase mb-4 font-semibold" data-id="element-7241" data-mp="1vte1nmkxzyay">
              Impact
            </motion.p>
            <motion.h2 {...fadeInUp} transition={{
            delay: 0.1
          }} className="font-serif text-4xl md:text-5xl text-[#fefaf3] mb-16" data-id="element-7242" data-mp="25rtrlm88h1iv">
              Every bus changes a generation.
            </motion.h2>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12" data-id="element-7243" data-mp="2fjpt779j39ru">
              <motion.div {...fadeInUp} transition={{
              delay: 0.2
            }} data-id="element-7244" data-mp="2tgcypyfjr89d">
                <div className="font-serif text-5xl md:text-6xl text-[#c89b3c] mb-2" data-id="element-7245" data-mp="z2lkelm9w07l">
                  50
                </div>
                <div className="text-[#fefaf3]/60 text-xs md:text-sm font-light uppercase tracking-wider" data-id="element-7246" data-mp="u5bsmzbevcgl">
                  Students per bus
                </div>
              </motion.div>
              <motion.div {...fadeInUp} transition={{
              delay: 0.3
            }} data-id="element-7247" data-mp="3apfb44a4qdr2">
                <div className="font-serif text-5xl md:text-6xl text-[#c89b3c] mb-2" data-id="element-7248" data-mp="310nma50d89kd">
                  12k+
                </div>
                <div className="text-[#fefaf3]/60 text-xs md:text-sm font-light uppercase tracking-wider" data-id="element-7249" data-mp="2n0mjgk0jis29">
                  Students in Year 1
                </div>
              </motion.div>
              <motion.div {...fadeInUp} transition={{
              delay: 0.4
            }} data-id="element-7250" data-mp="2d382mjapg19f">
                <div className="font-serif text-5xl md:text-6xl text-[#c89b3c] mb-2" data-id="element-7251" data-mp="2i3vtn4yxoi3n">
                  90m
                </div>
                <div className="text-[#fefaf3]/60 text-xs md:text-sm font-light uppercase tracking-wider" data-id="element-7252" data-mp="ga6bgg25ko0v">
                  Of immersive heritage
                </div>
              </motion.div>
              <motion.div {...fadeInUp} transition={{
              delay: 0.5
            }} data-id="element-7253" data-mp="28bziq5p5rba3">
                <div className="font-serif text-5xl md:text-6xl text-[#c89b3c] mb-2" data-id="element-7254" data-mp="23bbj4vmv5m49">
                  ∞
                </div>
                <div className="text-[#fefaf3]/60 text-xs md:text-sm font-light uppercase tracking-wider" data-id="element-7255" data-mp="1yfwb4kbjekfr">
                  Generational ripple
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* 6. For Sikh & Punjabi Business Leaders */}
        <section className="py-24 md:py-32 bg-[#fefaf3]" data-id="element-7256" data-mp="1kkaje5dx5mjn">
          <div className="container mx-auto px-6 max-w-6xl" data-id="element-7257" data-mp="1fod8wfpc7aes">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-7258" data-mp="1anxurlx8dyvr">
              <motion.div {...fadeInUp} data-id="element-7259" data-mp="1aq1urss0edqr">
                <p className="text-[#c89b3c] tracking-[0.2em] text-xs uppercase mb-4 font-semibold" data-id="element-7260" data-mp="15ouqw4szlypd">
                  A Call to Our Community
                </p>
                <h2 className="font-serif text-4xl md:text-5xl text-[#0f1729] mb-8 leading-tight" data-id="element-7261" data-mp="10kaen9kam70l">
                  For the leaders who build, the patrons who preserve.
                </h2>
                <div className="space-y-6 text-[#0f1729]/70 font-light leading-relaxed" data-id="element-7262" data-mp="15hizjhwtsp5j">
                  <p data-id="element-7263" data-mp="1agdoz2patbym">
                    Our community has built businesses, neighborhoods, and
                    institutions across Canada. We have established ourselves as
                    leaders in every industry.
                  </p>
                  <p data-id="element-7264" data-mp="msm1r427zeik">
                    This is the next institution worth building—a permanent
                    immersive home for our heritage. Sponsorship is not charity;
                    it is legacy. It is the continuation of our deepest values:{' '}
                    <em className="font-serif text-lg" data-id="element-7265" data-mp="3q7rr8x8bo95e">dasvandh</em> (giving a
                    tenth) and <em className="font-serif text-lg" data-id="element-7266" data-mp="3v6l02ccnzbz8">seva</em>{' '}
                    (selfless service).
                  </p>
                  <p data-id="element-7267" data-mp="3i9g595dzd9la">
                    Your name on the Heritage Wall stands beside the historical
                    figures the experience honors. You become an architect of
                    the future by preserving the past.
                  </p>
                </div>
                <div className="mt-10" data-id="element-7268" data-mp="3s12fayel12mg">
                  <a href="https://wa.me/14169998778?text=I%20would%20like%20to%20speak%20with%20the%20founders%20about%20Sikh%20Heritage%20Forward" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 border-b border-[#c89b3c] text-[#c89b3c] hover:text-[#0f1729] hover:border-[#0f1729] pb-1 text-sm tracking-[0.15em] uppercase font-medium transition-colors" data-id="element-7269" data-mp="34a6oo4lv4dgs">
                    <MessageCircleIcon className="w-4 h-4" data-id="element-7270" data-mp="oislm7v0lc8y" />
                    Speak with the Founders
                  </a>
                </div>
              </motion.div>

              <motion.div {...fadeInUp} transition={{
              delay: 0.2
            }} className="bg-[#f9f4ec] border border-[#c89b3c]/20 p-12 text-center" data-id="element-7271" data-mp="110lfdx2gueo9">
                <h3 className="font-serif text-3xl text-[#0f1729] mb-10" data-id="element-7272" data-mp="r3gstw4pkh6x">
                  Our Values
                </h3>
                <div className="space-y-10" data-id="element-7273" data-mp="1esry9qx06zre">
                  <div data-id="element-7274" data-mp="1jqtdu1v80gy4">
                    <div className="text-[#c89b3c] font-serif text-2xl mb-2" data-id="element-7275" data-mp="1jq1lr10u11cl">
                      Dasvandh
                    </div>
                    <div className="text-[#0f1729]/60 text-sm font-light" data-id="element-7276" data-mp="15xloyhyixzk4">
                      Contributing to the community's growth
                    </div>
                  </div>
                  <div data-id="element-7277" data-mp="1xpb2q2wv3zhm">
                    <div className="text-[#c89b3c] font-serif text-2xl mb-2" data-id="element-7278" data-mp="1xp19m6gitc7p">
                      Seva
                    </div>
                    <div className="text-[#0f1729]/60 text-sm font-light" data-id="element-7279" data-mp="1drgd38f80j47">
                      Selfless service for the next generation
                    </div>
                  </div>
                  <div data-id="element-7280" data-mp="140vf9n7dfimc">
                    <div className="text-[#c89b3c] font-serif text-2xl mb-2" data-id="element-7281" data-mp="140bttwiiic3k">
                      Vidya
                    </div>
                    <div className="text-[#0f1729]/60 text-sm font-light" data-id="element-7282" data-mp="z3v97caiufv8">
                      The pursuit and sharing of knowledge
                    </div>
                  </div>
                  <div data-id="element-7283" data-mp="1rs0t5wtr40u0">
                    <div className="text-[#c89b3c] font-serif text-2xl mb-2" data-id="element-7284" data-mp="1romryrwtpxo5">
                      Virasat
                    </div>
                    <div className="text-[#0f1729]/60 text-sm font-light" data-id="element-7285" data-mp="1hss2bcu6n2bv">
                      Preserving our rich cultural heritage
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* 7. Final CTA Section */}
        <section className="py-32 bg-[#0a0f1f] relative overflow-hidden text-center" data-id="element-7286" data-mp="2i1hs15d1args">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_var(--tw-gradient-stops))] from-[#c89b3c]/10 via-[#0a0f1f] to-[#0a0f1f]" data-id="element-7287" data-mp="2mz9swovnpnx4"></div>
          <div className="container mx-auto px-6 relative z-10 max-w-4xl" data-id="element-7288" data-mp="2rwt7jpw9o2pl">
            <motion.h2 {...fadeInUp} className="font-serif text-5xl md:text-7xl text-[#fefaf3] mb-2 tracking-tight" data-id="element-7289" data-mp="2wqe5jhxv0wos">
              Sponsor a bus.
            </motion.h2>
            <motion.h2 {...fadeInUp} transition={{
            delay: 0.1
          }} className="font-serif text-5xl md:text-7xl text-[#c89b3c] mb-8 tracking-tight" data-id="element-7290" data-mp="35ohi3oqvaj4g">
              Pay heritage forward.
            </motion.h2>

            <motion.p {...fadeInUp} transition={{
            delay: 0.2
          }} className="text-[#fefaf3]/60 font-light mb-12 max-w-xl mx-auto text-lg" data-id="element-7291" data-mp="1gcxhp71zh17n">
              Join the visionary leaders ensuring our history is experienced,
              not forgotten.
            </motion.p>

            <motion.div {...fadeInUp} transition={{
            delay: 0.3
          }} className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16" data-id="element-7292" data-mp="wybfpqymls9l">
              <a href="https://wa.me/14169998778?text=I%20would%20like%20to%20sponsor%20a%20bus%20for%20Sikh%20Heritage%20Forward" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#c89b3c] hover:bg-[#b8860b] text-[#0a0f1f] px-8 py-4 text-sm tracking-[0.15em] uppercase font-medium transition-colors duration-300" data-id="element-7293" data-mp="1po1ywef47kck">
                Sponsor a Bus
              </a>
              <a href="https://wa.me/14169998778?text=I%20would%20like%20to%20become%20a%20Patron%20for%20Sikh%20Heritage%20Forward" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 border border-[#c89b3c] text-[#c89b3c] hover:bg-[#c89b3c] hover:text-[#0a0f1f] px-8 py-4 text-sm tracking-[0.15em] uppercase font-medium transition-colors duration-300" data-id="element-7294" data-mp="9a20j7vx42rf">
                Become a Patron
              </a>
            </motion.div>

            <motion.div {...fadeInUp} transition={{
            delay: 0.4
          }} data-id="element-7295" data-mp="1zrgss8a1iujv">
              <Link to="/" className="inline-flex items-center gap-2 text-[#fefaf3]/40 hover:text-[#c89b3c] text-xs tracking-[0.15em] uppercase font-light transition-colors" data-id="element-7296" data-mp="2djdhs3gewoc1">
                <ArrowLeftIcon className="w-3 h-3" data-id="element-7297" data-mp="1h062ntc52lt1" />
                Back to Main Site
              </Link>
            </motion.div>
          </div>
        </section>

        <Footer data-id="element-7298" data-mp="3g4egl52tc8j6" />
      </div>
    </LanguageProvider>;
}